
import ready from "./functions/document_ready";
import isGutenberg from "./functions/is_gutenberg";
import decode from "./functions/decode";

import ImageUploader from "../components/ImageUploader";
import ServerSideRenderAvecInnerBlocks from "../components/ServerSideRenderAvecInnerBlocks"
import AlignToolbar from "../components/AlignToolbar";
import IconSelectorFields from "../components/IconSelectorFields";
import FormatedFaIcon from "../components/FormatedFaIcon";
import Loader from "../components/Loader";


window.cdm_blocks = {
    fn: {
        ready,
        isGutenberg,
        decode
    },
    components: {
        ServerSideRenderAvecInnerBlocks,
        ImageUploader,
        AlignToolbar,
        IconSelectorFields,
        FormatedFaIcon,
        Loader
    }
}